import { createFileRoute } from '@tanstack/react-router';
import { AceitarConvitePage } from '@/components/convite';

/** Publica e fora do shell: quem recebe o link ainda nao tem conta. O token vem na URL (`?token=`). */
export const Route = createFileRoute('/convite')({
  validateSearch: (bruto: Record<string, unknown>) => ({ token: typeof bruto.token === 'string' && bruto.token.length >= 20 && bruto.token.length <= 200 ? bruto.token : undefined }),
  component: ConviteRota,
});

function ConviteRota() {
  return <AceitarConvitePage token={Route.useSearch().token} />;
}
